'use client';

import { ApiKeys, fetcher } from '@insta-club/api';
import { HourglassIcon } from '@insta-club/components/icons';
import { SubscriptionPlan } from '@insta-club/models';
import { useSessionStore } from '@insta-club/state';
import { t } from '@insta-club/translations';
import { Button, Modal } from '@insta-club/ui';
import { cn, separator } from '@insta-club/utilities';
import { useState } from 'react';
import toast from 'react-hot-toast';
import { mutate } from 'swr';

interface ReservedPlanItemProps {
    item: SubscriptionPlan;
    last: boolean;
    first: boolean;
    active: boolean;
}

export default function ReservedPlanItem({ item, active }: ReservedPlanItemProps) {
    const [planStore, setPlanStore] = useState<{ hasReserved: boolean; dialog: boolean; refundAmout: number }>({
        hasReserved: false,
        dialog: false,
        refundAmout: 0
    });

    const [loading, setLoading] = useState(false);
    const activePageSession = useSessionStore((state) => state.page);

    const pageId = String(activePageSession?.id);
    const planId = String(item.id);

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const activeHandler = async () => {
        if (active) {
            setLoading(true);
            await fetchComputedRefund();
        }
        setPlanStore((prev) => ({ ...prev, dialog: true, hasReserved: active }));
    };

    const fetchComputedRefund = async () => {
        try {
            const res = await fetcher(ApiKeys.GET_SUBSCRIPTION_REFUND(pageId), 'dashboard', 'GET');
            setPlanStore((prev) => ({ ...prev, refundAmout: res?.amount ?? 0 }));
        } catch {
            toast.error(t('please_try_again'));
        } finally {
            setLoading(false);
        }
    };

    const activateReservedPlan = async () => {
        try {
            setLoading(true);
            await fetcher(ApiKeys.POST_ACTIVE_RESERVE_SUBSCRIPTION(pageId, planId), 'dashboard', 'POST');
            mutate(ApiKeys.GET_ACTIVE_PLAN_SUBSCRIPTION(pageId));
        } catch {
            toast.error(t('please_try_again'));
        } finally {
            setLoading(false);
            setPlanStore((prev) => ({ ...prev, dialog: false }));
        }
    };

    return (
        <>
            <div className={cn('shadow-card space-y-5 bg-white p-4', 'rounded-2xl')}>
                <div className='flex items-center gap-2'>
                    <div className='flex h-9 w-9 items-center justify-center rounded-full bg-gray-100'>
                        <HourglassIcon width={18} height={18} className='text-gray-500' />
                    </div>
                    {/* <Image src='/icons/apple-touch-icon.png' width={40} height={40} alt='pp' className='rounded-full' /> */}
                    {/* <CircularProgressImage
                        src={item.plan.plan_type.image ?? '/icons/apple-touch-icon.png'}
                        alt='plan'
                        progress={((item.days - item.days_lefted) / item.days) * 100}
                        size={40}
                        strokeColor='#4D4DA7'
                    /> */}

                    <div className='flex flex-1 items-start justify-between'>
                        <div className='flex flex-col items-start gap-1.5'>
                            <span className='text-sm font-bold text-gray-900'>
                                {item?.plan.plan_type.name + ' ' + item?.plan.name}
                                {/* {t('subscription', item?.plan.plan_type.name + ' ' + item?.plan.name)} */}
                            </span>
                            {/* <span className='text-xs text-gray-600'>رزرو شده است</span> */}
                            <p className='text-xs'>
                                پس از پایان اشتراک فعال ، اشتراک رزرو بصورت خودکار فعال خواهد شد .
                            </p>
                            {/* <p className='text-xs'>
                                پس از اتمام اشتراک فعال، اشتراک رزرو {item.plan.plan_type.name} فعال خواهد شد.
                            </p> */}
                        </div>
                    </div>
                </div>
                {/* <div className='flex justify-end'>
                    <div className='flex items-center gap-2'>
                        <span
                            onClick={activeHandler}
                            className={cn(
                                'border-primary-700 text-primary-700 cursor-pointer rounded-2xl border px-4 py-0.5 text-xs font-medium'
                            )}
                        >
                            {!loading ? 'فعال‌سازی' : 'فعال‌سازی...'}
                        </span>
                    </div>
                </div> */}
            </div>

            <Modal
                isOpen={planStore.dialog}
                onClose={() => {
                    setPlanStore((prev) => ({ ...prev, dialog: false }));
                }}
                title={`فعال سازی اشتراک ${planStore.hasReserved ? 'رزرو' : ''}`}
            >
                <div className='flex flex-col gap-6 text-sm leading-relaxed'>
                    {!planStore.hasReserved && (
                        <p>
                            با فعالسازی اشتراک ویژه شما به تمامی امکانات اینستا کلاب دسترسی خواهید داشت. آیا میخواهید
                            اشتراک ویژه پیج {activePageSession?.page} را هم اکنون فعال کنید؟
                        </p>
                    )}

                    {planStore.hasReserved && (
                        <p>
                            با فعال سازی اشتراک رزرو ، اشتراک فعال شما لغو و مبلغ {separator(planStore.refundAmout)}{' '}
                            تومان به کیف پول شما واریز خواهد شد
                        </p>
                    )}

                    <div className='flex gap-2'>
                        <Button loading={loading} onClick={activateReservedPlan} size='sm' fullWidth>
                            {t('confirmation')}
                        </Button>
                        <Button
                            onClick={() => {
                                setPlanStore((prev) => ({ ...prev, dialog: false }));
                            }}
                            size='sm'
                            color='gray'
                            fullWidth
                        >
                            انصراف
                        </Button>
                    </div>
                </div>
            </Modal>
        </>
    );
}

